import React, { useRef, useEffect, useState } from "react";
import lock from "../../../assets/logos/icons-lock.png";
import unlock from "../../../assets/logos/icons-unlock.png";
import p5 from "p5";
import { useTranslation } from "react-i18next";

let validation = { activeOnSubit: false };

export default function P5Contianer({
  widthImg,
  heightImg,
  base64Img,
  // imgSignature,
  widthImgSignature,
  heightImgSignature,
  save,
  activeOnSubit,
  back,
  isAndroid,
  gotToEnd,
  isPhone,
  signatures,
  currentPage,
  coordinates,
  insertSign,
  currentUser,
  documentNameToShowInSign,
  documentsPackage
}) {
  if (activeOnSubit !== validation.activeOnSubit) {
    validation.activeOnSubit = activeOnSubit;
  }
  const p5Ref = useRef();
  const [p5Canvas, setp5Canvas] = useState(null);
  const { t } = useTranslation()
  const Sketch = (sketch) => {
    let page = null;
    let isSubmit = false;
    let cancelBtn;
    // let backBtn;
    let signBtn;
    let signBtnText;
    let xRect = widthImg * 0.55;
    let yRect = heightImg * 0.75;
    let wRect = widthImgSignature / 3;
    let hRect = heightImgSignature / 3;
    let signature = null;
    let isActiveCircleTopLeft = false;
    let isActiveCircleBottomLeft = false;
    let isActiveCircleTopRight = false;
    let overImage = false;
    let locked = false;
    let xOffSet = 0;
    let yOffSet = 0;
    let done = false;
    let lockImg = null;
    let unlockImg = null;
    let isLock = false;
    let savePostion = {};

    sketch.preload = () => {
      page = sketch.loadImage(base64Img);
      // signature = sketch.loadImage(imgSignature);
      lockImg = sketch.loadImage(lock);
      unlockImg = sketch.loadImage(unlock);
    };
    sketch.setup = () => {
      sketch.createCanvas(widthImg, heightImg + 70);
      sketch.textSize(15);
      sketch.noStroke();
      signBtn = sketch.createButton(t("button.send"));
      cancelBtn = sketch.createButton(t("button.exit"));
      if (widthImg < 550) {
        cancelBtn.position(
          widthImg / 2 - 47.5 - 32 - 95 - 10 + 111,
          heightImg + 70 + (isPhone ? 200 : 100)
        );
        signBtn.position(
          widthImg / 2 - 47.5 + 16 + 95 + 50 + 50,
          heightImg + 70 + (isPhone ? 200 : 100)
        );
      } else {
        cancelBtn.position(
          widthImg / 2 - 47.5 - 32 + 230 - 10,
          heightImg + 70 + (isPhone ? 200 : 100)
        );
        signBtn.position(
          widthImg / 2 - 47.5 + 16 + 95 + 50,
          heightImg + 70 + (isPhone ? 200 : 100)
        );
      }
      signBtn.mouseClicked(() => {
        save(signatures);
      });
      signBtn.class("canvasBtnHidden");
      cancelBtn.class("canvasCancelBtn");
      cancelBtn.mouseClicked(() => {
        back();
      });
      if (coordinates) {
        if (documentsPackage && documentsPackage.length > 0 && documentsPackage[0].groupName === process.env.REACT_APP_DOCUMENT_PROFILE_DEFAULT_GROUPNAME) {
          let coorFind = coordinates.filter(coordinate => coordinate.document === documentNameToShowInSign)
          coordinates = coorFind
        }

        for (let i = 0; i < coordinates.length; i++) {
          const item = coordinates[i];
          if (item.page === currentPage) {
            signBtn = sketch.createButton(signatures[i].imgSignature ? "" : currentUser);
            signBtnText = sketch.createButton(t(""));



            signBtnText.position(
              item.x + 65,
              -item.y + 195 + heightImg - hRect + (isPhone ? -45 : 0),
              "relative "
            );

            signBtn.position(
              item.x + 95,
              -item.y + 150 + heightImg - hRect + (isPhone ? -50 : 0),
              "relative "
            );

            signBtnText.class("buttonQueTalvezEsCanvas");
            if (signatures[i].imgSignature) {
              signBtn.class("buttonQueSiEsCanvas");
            } else {
              signBtn.class("buttonQueNoEsCanvas");
            }

            signBtnText.mouseClicked(() => {
              let data = {
                x: item.x,
                y: -item.y + heightImg - hRect,
                width: 208,
                height: 100,
                savePostion,
                index: i + 1,
                page: item.page,
                heightImg: heightImg
              };
              data.y = heightImg - data.y - data.height;
              insertSign(data);
            })

            signBtn.mouseClicked(() => {

              let data = {
                x: item.x,
                y: -item.y + heightImg - hRect,
                width: 208,
                height: 100,
                savePostion,
                index: i + 1,
                page: item.page,
                heightImg: heightImg
              };
              data.y = heightImg - data.y - data.height;
              insertSign(data);
            })
          }
        }
      }
    };
    sketch.draw = () => {
      let widthRect = wRect;
      let heightRect = hRect;
      let initX = xRect;
      let initY = yRect;
      sketch.background(220);
      sketch.fill("#005DA1");
      sketch.rect(0, 0, widthImg + 2, heightImg + 2);
      sketch.fill(255);
      sketch.image(page, 1, 2, widthImg - 2, heightImg - 2);

      if (isActiveCircleTopLeft) {
        initX = sketch.mouseX;
        initY = sketch.mouseY;
        widthRect = widthRect + xRect - sketch.mouseX;
        heightRect = heightRect + yRect - sketch.mouseY;
      }
      if (isActiveCircleTopRight) {
        widthRect = sketch.mouseX - xRect;
        initY = sketch.mouseY;
        heightRect = heightRect + yRect - sketch.mouseY;
      }
      if (isActiveCircleBottomLeft) {
        initX = sketch.mouseX;
        widthRect = widthRect + xRect - sketch.mouseX;
        heightRect = sketch.mouseY - yRect;
      }
      if (
        sketch.mouseX >= initX + 5 &&
        sketch.mouseX <= initX + widthRect - 5 &&
        sketch.mouseY >= initY + 5 &&
        sketch.mouseY <= initY + heightRect - 5
      ) {
        let isCurrent = false;
        isCurrent = overImage || isCurrent;
        if (!isCurrent && !done) overImage = true;
      } else overImage = false;

      sketch.stroke("#fff");
      sketch.rect(0, heightImg + 2, widthImg, 100);

      let s = 'The quick brown fox jumped over the lazy dog.';

    };

  };
  useEffect(() => {
    setp5Canvas(new p5(Sketch, p5Ref.current));
    setTimeout(() => {
      gotToEnd();
    }, 100);
  }, []);

  return <div className="p5Container" ref={p5Ref} />;
}
